module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header campaign-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Campaigns")]), _vm._v(" "), _c('campaign-filter', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "inline"
    },
    on: {
      "onFilter": _vm.handleFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [(_vm.$apollo.queries.campaignList.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your campaigns"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (
    !_vm.$apollo.queries.campaignList.loading &&
    _vm.campaignList.objects &&
    !_vm.campaignList.objects.length
  ) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.$apollo.queries.campaignList.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._l((_vm.campaignList.objects), function(item) {
    return _c('campaign-list-item', {
      key: item.id,
      attrs: {
        "id": parseInt(item.id, 10),
        "title": item.title,
        "live": item.live,
        "perpetual": item.perpetual,
        "progress": item.progress,
        "advertiser": item.campaignadvertiser && item.campaignadvertiser.advertiser,
        "startDate": _vm.moment(item.startDate),
        "endDate": _vm.moment(item.endDate),
        "createdBy": item.createdBy,
        "campaignType": item.campaignType,
        "totalMessages": item.engagements.total,
        "uniqueMessages": item.engagements.unique,
        "totalThisMonth": item.engagements.totalThisMonth,
        "totalPerDayThisMonth": item.engagements.totalPerDayThisMonth,
        "channelLinks": item.linkedcampaignchannelSet,
        "replyMessage": _vm.displayReplyMessage(item.replymessage),
        "growth": item.engagements.growth,
        "isFavourite": item.favourite,
        "topEngagers": item.engagements.topEngagers,
        "survey": _vm.getSurvey(item.survey),
        "bots": _vm.getBotsLinks(item.linkedcampaignchannelSet),
        "leadCount": item.leadCount
      },
      on: {
        "onRandomSelect": function($event) {
          return _vm.handleRandomSelect(item.id)
        },
        "onRandomSelections": function($event) {
          return _vm.handleRandomSelections(item.id)
        },
        "onDownloadMessages": function($event) {
          return _vm.handleDownloadMessages(item)
        },
        "onEditCampaign": function($event) {
          return _vm.handleCampaignEdit(item.id)
        },
        "onFavourite": function($event) {
          return _vm.handleFavourite($event, item.id)
        },
        "onToggleLiveStatus": function($event) {
          return _vm.handleToggleLiveStatus($event, item.id)
        },
        "onUnlink": function($event) {
          return _vm.handleUnlink($event, item.id)
        },
        "onSelectProfile": function($event) {
          return _vm.handleSelectProfile($event)
        },
        "onExportSurveyData": function($event) {
          return _vm.handleExportSurveyData(item.survey)
        },
        "onDownloadBotReport": function($event) {
          return _vm.handleDownloadBotReport(item)
        }
      }
    })
  }), _vm._v(" "), (_vm.profileDialogVisible && _vm.selectedProfile) ? _c('profile-detail-dialog', {
    attrs: {
      "originalProfile": _vm.selectedProfile,
      "updatedProfileMap": _vm.updatedProfileMap,
      "profileDialogVisible": _vm.profileDialogVisible,
      "profileId": _vm.getProfileId(_vm.selectedProfile),
      "campaignId": _vm.selectedCampaignForProfile
    },
    on: {
      "onDialogVisibilityChange": _vm.handleProfileDialogVisibilityChanged,
      "profileUpdated": _vm.handleProfileUpdated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.campaignList.pages > 1) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.campaignList.objects) ? _c('paginator', {
    attrs: {
      "id": "paginator",
      "hasNext": _vm.campaignList.hasNext,
      "hasPrevious": _vm.campaignList.hasPrev,
      "pages": _vm.campaignList.pages,
      "currentPage": _vm.campaignList.page
    },
    on: {
      "goToNextPage": _vm.handleNextPage,
      "goToPreviousPage": _vm.handlePreviousPage,
      "goToPage": _vm.handleGoToPage
    }
  }) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), (_vm.campaignManageVisible) ? _c('campaign-manage', {
    attrs: {
      "me": _vm.me,
      "campaignToEdit": _vm.campaignToEdit,
      "editingCampaign": _vm.editCampaign,
      "isVisible": _vm.campaignManageVisible,
      "addingInstagramChannel": _vm.addingInstagramChannel,
      "addingTwitterChannel": _vm.addingTwitterChannel
    },
    on: {
      "onVisibleChanged": _vm.handleCreateCampaignVisibilityChanged,
      "onRequestTwitterAuth": _vm.handleRequestTwitterAuth,
      "onRequestInstagramAuth": _vm.handleRequestInstagramAuth,
      "onSaved": _vm.handleCampaignCreated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.campaignList && _vm.campaignList.objects && _vm.campaignList.objects.length > 0) ? _c('div', [(_vm.randomSelectVisible) ? _c('random-select-dialog', {
    attrs: {
      "isVisible": _vm.randomSelectVisible,
      "campaignId": _vm.randomSelectCampaignId
    },
    on: {
      "onVisibleChanged": _vm.handleRandomSelectVisibilityChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.randomSelectionsVisible) ? _c('random-selections-dialog', {
    attrs: {
      "isVisible": _vm.randomSelectionsVisible,
      "campaignId": _vm.randomSelectCampaignId
    },
    on: {
      "onVisibleChanged": _vm.handleRandomSelectionsVisibilityChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.downloadMessagesVisible) ? _c('download-messages-dialog', {
    attrs: {
      "channelLinks": _vm.selectedChannelLink['linkedcampaignchannelSet'],
      "isVisible": _vm.downloadMessagesVisible,
      "campaignId": parseInt(_vm.selectedChannelLink['id'], 10),
      "campaignTitle": _vm.selectedChannelLink['title']
    },
    on: {
      "onVisibleChanged": _vm.handleDownloadMessagesVisibilityChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.downloadBotReportVisible) ? _c('bot-report-dialog', {
    attrs: {
      "channelLinks": _vm.getBotsLinks(_vm.selectedChannelLink['linkedcampaignchannelSet']),
      "isVisible": _vm.downloadBotReportVisible,
      "campaignId": parseInt(_vm.selectedChannelLink['id'], 10),
      "campaignTitle": _vm.selectedChannelLink['title']
    },
    on: {
      "onVisibleChanged": _vm.handleDownloadBotReportVisibilityChanged
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('can', {
    attrs: {
      "action": "create",
      "subject": "campaigns"
    }
  }, [_c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "mainTooltip": "New campaign"
    },
    on: {
      "click": _vm.handleCreateCampaign
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No campaigns found.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfb0b9b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/CampaignDashboard.vue
// module id = 3406
// module chunks = 3